import script from "./sectionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./sectionsView.vue?vue&type=script&setup=true&lang=ts"

import "./sectionsView.vue?vue&type=style&index=0&id=9a69db8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a69db8e"]])

export default __exports__